import { useState,useContext } from 'react';
import {  NavLink, useLocation,useNavigate } from "react-router-dom";
import { Button, Form, Container, Nav, Navbar, NavDropdown, Badge, Offcanvas, ListGroup } from 'react-bootstrap';
import { CiSearch } from 'react-icons/ci';
import { SlCalender } from 'react-icons/sl';
import { UserContext } from "../../context/UserContextProvider";
import { setCookies } from "../../utils/Helper";
import NotificationDropdown from '../../components/Notification/notification';
const Header = () => {
    const { accessToken, data, logout } = useContext(UserContext);
    const [notifications, setNotifications] = useState(8); // Example count
    const [show, setShow] = useState(false);
    const Navigate = useNavigate();

    const handleLogout = (e) => {
        e.preventDefault();
        logout();
        setCookies("accessToken", null);
        setCookies("user_type", null);
        setCookies("role_id", null);
        setCookies("name", null);
        Navigate("/");
      };

    return (
        <>
            <header>
                <Navbar className="">
                    <Container fluid>
                        <Navbar.Brand href="#"><img src="/images/msl_logo.png" className='img-fluid ' alt='logo' /></Navbar.Brand>
                        <Navbar.Toggle aria-controls="navbarScroll" />
                        <Navbar.Collapse id="navbarScroll" >
                            <Nav
                                className="ms-auto my-2 my-lg-0 align-items-center gap-3"
                                style={{ maxHeight: '100px' }}
                                navbarScroll
                            >
                                <Nav.Item>
                                    <NavDropdown
                                        title={
                                            <span className="d-flex align-items-center">
                                               
                                                 {
                                                    data?.profile_pic ?
                                                        <img
                                                            src={data.profile_pic}
                                                            alt="User"
                                                            className="rounded-circle me-2"
                                                            width="30"
                                                            height="30"
                                                        />
                                                        :
                                                        <img src="/images/user.png"
                                                            className="rounded-circle me-2"
                                                            alt="default img"
                                                              width="30"
                                                            height="30"
                                                        />
                                                }

                                            </span>
                                        }
                                        id="user-dropdown"
                                        align="end"
                                    >
                                        <NavDropdown.Item as={NavLink} to="/admin/profile" >Profile</NavDropdown.Item>
                              
                                        <NavDropdown.Divider />
                                        <NavDropdown.Item href="/logout" onClick={(e) => handleLogout(e)}>Logout</NavDropdown.Item>
                                    </NavDropdown>
                                </Nav.Item>
                            </Nav>

                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </header>

        </>


    )
}




export default Header